export const buildNumber = '20260220.7';
export const version = 'main';
export const latestCommit = 'f0ea3416666cc73f6fc7d615186ac1ad348e6bc4';
